import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getInfrastructureTags(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS,
		options
	)
}

function _getInfrastructureTagsPreview(options={}) {
	return _apiRequestWrap(ModulesMap.INFRASTRUCTURE_TAGS, ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS_PREVIEW, options)
}

function _createInfrastructureTags(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].CREATE_INFRASTRUCTURE_TAGS,
		options
	)
}

function _getInfrastructureTag(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAG,
		options
	)
}

function _patchInfrastructureTags(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PATCH_INFRASTRUCTURE_TAGS,
		options
	)
}

function _putInfrastructureTags(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PUT_INFRASTRUCTURE_TAGS,
		options
	)
}

function _deleteInfrastructureTags(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TAGS,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].DELETE_INFRASTRUCTURE_TAGS,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS]: _getInfrastructureTags,

	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAGS_PREVIEW]: _getInfrastructureTagsPreview,

	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].CREATE_INFRASTRUCTURE_TAGS]: _createInfrastructureTags,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].GET_INFRASTRUCTURE_TAG]: _getInfrastructureTag,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PATCH_INFRASTRUCTURE_TAGS]: _patchInfrastructureTags,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].PUT_INFRASTRUCTURE_TAGS]: _putInfrastructureTags,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TAGS].DELETE_INFRASTRUCTURE_TAGS]: _deleteInfrastructureTags,
}